<script>
    import { links } from "svelte-navigator";

    export let username;
</script>

<h2>Home page</h2>

<div use:links>
    {#if username}
        <p><a href="/user_page" noroute>ส่งคำร้อง</a></p>
        <p><a href="/user/edit_user_profile" noroute>ดูข้อมูลส่วนตัว</a></p>
    {:else}
        <p><a href="/user/register" noroute>สมัครสมาชิก</a></p>
        <p><a href="/user/sign-in" noroute>เข้าสู่ระบบ</a></p>
    {/if}
</div>
